<template>
  <div class="card text-center">
    <div class="card-header" :class="ThemeTitleModal">
      <ul
        class="nav nav-tabs mt-3 card-header-tabs"
        id="myTab"
        role="tablist"
        dir="rtl"
      >
        <li class="nav-item">
          <a
            class="nav-link active"
            id="Detail-tab"
            data-toggle="tab"
            href="#Detailtab"
            role="tab"
            aria-controls="Detailtab"
            aria-selected="true"
            >اطلاعات شعبه</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="Logo-tab"
            data-toggle="tab"
            href="#Logotab"
            role="tab"
            aria-controls="Settingtab"
            aria-selected="true"
            >لوگو شعبه</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="Setting-tab"
            data-toggle="tab"
            href="#Settingtab"
            role="tab"
            aria-controls="Settingtab"
            aria-selected="true"
            >تنظیمات</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="ProfessionalSettings-tab"
            data-toggle="tab"
            href="#ProfessionalSettings"
            role="tab"
            aria-controls="ProfessionalSettingstab"
            aria-selected="true"
            >تنظیمات پانل حرفه ای</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="Activedirectory-tab"
            data-toggle="tab"
            href="#Activedirectory"
            role="tab"
            aria-controls="Activedirectorytab"
            aria-selected="true"
            >اکتیو دایرکتوری</a
          >
        </li>
      </ul>
    </div>
    <div class="tab-content text-right" id="Controler">
      <div
        class="tab-pane fade show active"
        id="Detailtab"
        role="tabpanel"
        aria-labelledby="Detail-tab"
      >
        <div id="Controler">
          <div class="container mt-3 mb-3">
            <div class="row">
              <div class="col-lg-6 col-12">
                <small>نام شعبه</small>
                <input
                  type="text"
                  id="NameShobe"
                  class="form-control InputText"
                  v-model="DataAxios.NameShobe"
                />
              </div>
              <div class="col-lg-3 col-12">
                <small>کد شعبه</small>
                <input
                  type="text"
                  id="CodeShobe"
                  class="form-control InputText"
                  v-model="DataAxios.CodeShobe"
                />
              </div>
              <div class="col-lg-3 col-12">
                <small>شماره شعبه</small>
                <input
                  id="shomareShobe"
                  class="form-control Input"
                  v-model.number="DataAxios.ShomareShobe"
                  type="number"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6 col-12">
                <small>تلفن</small>
                <input
                  type="text"
                  id="tel"
                  class="form-control InputText"
                  v-model="DataAxios.Tel"
                />
              </div>
              <div class="col-lg-6 col-12">
                <small>نمابر</small>
                <input
                  type="text"
                  id="fax"
                  class="form-control InputText"
                  v-model="DataAxios.Fax"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6 col-12">
                <small>کد پستی</small>
                <input
                  type="text"
                  id="codePosti"
                  class="form-control InputText"
                  v-model="DataAxios.CodePosti"
                />
              </div>
              <div class="col-lg-3 col-12">
                <small>شناسه ملی</small>
                <input
                  type="text"
                  id="shenaseMeli"
                  class="form-control InputText"
                  v-model="DataAxios.ShenaseMeli"
                />
              </div>
              <div class="col-lg-3 col-12">
                <small>ثبت</small>
                <input
                  type="text"
                  id="sabtNo"
                  class="form-control InputText"
                  v-model="DataAxios.SabtNo"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-12 col-12">
                <small>آدرس</small>
                <input
                  type="text"
                  id="adres"
                  class="form-control InputText"
                  v-model="DataAxios.Adres"
                />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-lg-5 col-12">
                <small>نام لاتین</small>
                <input
                  type="text"
                  id="nameLatinShobe"
                  class="form-control text-left InputText"
                  v-model="DataAxios.NameLatinShobe"
                />
              </div>
              <div class="col-lg-4 col-12">
                <small>تاریخ تاسیس</small>
                <date-picker
                  v-model="DataAxios.TarixTasis"
                  color="#ff9800"
                ></date-picker>
                <input
                  type="text"
                  id="tarixTasis"
                  class="d-none InputText"
                  v-model="DataAxios.TarixTasis"
                />
              </div>

              <div class="col-lg-3 col-12">
                <small>ارسال پیامک</small>
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="isSmsactive"
                      @click="statusChk($event)"
                      :v-model="IsSmsactive"
                    />
                    <label class="custom-control-label" for="isSmsactive"
                      >ارسال پیامک</label
                    >
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="Logotab"
        role="tabpanel"
        aria-labelledby="Logo-tab"
      >
        <div class="container mt-3 mb-3">
          <p class="alert alert-warning">
            برای بارگذاری لوگو بر روی دکمه بارگذاری کلیک کنید
          </p>
          <vue-upload-multiple-image
            :dragText="TitleUploaderLogo"
            :browseText="ClearDescriptionUploaderLogo"
            :primaryText="InfoUploaderLogo"
            :popupText="DtlInfoUploaderLogo"
            :multiple="MultipleImaegs"
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"
            @edit-image="editImage"
            @data-change="dataChange"
            :data-images="images"
          ></vue-upload-multiple-image>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="Settingtab"
        role="tabpanel"
        aria-labelledby="Setting-tab"
      >
        <div class="container mt-3 mb-3">
          <div class="row">
            <div class="col-lg-4 col-12">
              <small>اعتبار کلمه عبور ( روز )</small>
              <input
                type="text"
                id="etebarPasswordBeroz"
                class="form-control InputText"
                v-model="DataAxios.EtebarPasswordBeroz"
              />
            </div>
            <div class="col-lg-4 col-12">
              <small>زمان غیرفعال بودن کاربر ( دقیقه )</small>
              <input
                type="text"
                id="userTimeOut"
                class="form-control InputText"
                v-model="DataAxios.UserTimeOut"
              />
            </div>
            <div class="col-lg-4 col-12">
              <small>تعداد مجاز ورود نا موفق</small>
              <input
                type="text"
                id="howManyVerify"
                class="form-control InputText"
                v-model="DataAxios.HowManyVerify"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-12 col-12">
              <small>آدرس وب سرویس پیامک</small>
              <input
                type="text"
                id="smswebService"
                class="form-control InputText"
                v-model="DataAxios.SmswebService"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <small>نام کاربری پانل</small>
              <input
                type="text"
                id="smsuserName"
                class="form-control InputText"
                v-model="DataAxios.SmsuserName"
              />
            </div>
            <div class="col-lg-6 col-12">
              <small>کلمه عبور کاربری پانل</small>
              <input
                type="password"
                id="smspass"
                class="form-control InputText"
                v-model="DataAxios.Smspass"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <small>شماره تلفن پانل</small>
              <input
                type="text"
                id="smsnumber"
                class="form-control InputText"
                v-model="DataAxios.Smsnumber"
              />
            </div>
            <div class="col-lg-6 col-12">
              <small>دریافت نسخه جدید</small>
              <input
                type="text"
                id="getVersionSite"
                class="form-control InputText"
                v-model="DataAxios.GetVersionSite"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <small>آدرس سامانه اینترنتی</small>
              <input
                type="text"
                id="webSiteUrl"
                class="form-control InputText"
                v-model="DataAxios.WebSiteUrl"
              />
            </div>
            <div class="col-lg-6 col-12">
              <small>فشردگی پیام</small>
              <span class="form-control p-1">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input InputText"
                    id="smsexpect"
                    @click="statusChk($event)"
                    :value="checkedCompressedSms"
                  />
                  <label class="custom-control-label" for="smsexpect"
                    >فشردگی پیام</label
                  >
                  <!-- *************************************
                            ************************************* -->
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="ProfessionalSettings"
        role="tabpanel"
        aria-labelledby="ProfessionalSettings-tab"
      >
        <div class="container mt-3 mb-3">
          <div class="row mt-2">
            <div class="col-lg-12 col-12">
              <small>آدرس وب سرویس پیامک</small>
              <input
                type="text"
                id="smswebService2"
                class="form-control InputText"
                v-model="DataAxios.SmswebService2"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <small>نام کاربری پانل</small>
              <input
                type="text"
                id="smsuserName2"
                class="form-control InputText"
                v-model="DataAxios.SmsuserName2"
              />
            </div>
            <div class="col-lg-6 col-12">
              <small>کلمه عبور پانل</small>
              <input
                type="password"
                id="smspass2"
                class="form-control InputText"
                v-model="DataAxios.Smspass2"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <small>شماره تلفن پانل</small>
              <input
                type="text"
                id="smsnumber2"
                class="form-control InputText"
                v-model="DataAxios.Smsnumber2"
              />
            </div>
            <div class="col-lg-6 col-12">
              <small>ارسال خودکار پیام دریافتی به شماره</small>
              <input
                type="password"
                id="replyTextToSenderAfterSmsResive"
                class="form-control InputText"
                v-model="DataAxios.ReplyTextToSenderAfterSmsResive"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <span class="form-control p-1">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input InputText"
                    id="showNameInFirst"
                    @click="statusChk($event)"
                    :value="NameInFirst"
                  />
                  <label class="custom-control-label" for="showNameInFirst"
                    >نمایش نام در ابتدا</label
                  >
                </div>
              </span>
            </div>
            <div class="col-lg-6 col-12">
              <span class="form-control p-1">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input InputText"
                    id="donotResiveSms"
                    @click="statusChk($event)"
                    :value="CanGetSms"
                  />
                  <label class="custom-control-label" for="donotResiveSms"
                    >عدم دریافت پیامک</label
                  >
                </div>
              </span>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6 col-12">
              <small>پاسخ خودکار دریافت پیامک</small>
              <input
                type="text"
                id="sendSmsToMobileNoAfterSmsResive"
                class="form-control InputText"
                v-model="DataAxios.SendSmsToMobileNoAfterSmsResive"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="Activedirectory"
        role="tabpanel"
        aria-labelledby="Activedirectory-tab"
      >
        <div class="container mt-3 mb-3">
          <div class="row mt-2">
            <div class="col-lg-12 col-12">
              <small>نام سروز</small>
              <input
                type="text"
                id="NetServer"
                class="form-control InputText"
                v-model="DataAxios.NetServer"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-12 col-12">
              <small>نام دامنه</small>
              <input
                type="text"
                id="NetDomain"
                class="form-control InputText"
                v-model="DataAxios.NetDomain"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-12 col-12">
              <small>آخرین کاربر</small>
              <input
                type="text"
                id="NetLastUserName"
                class="form-control InputText"
                v-model="DataAxios.NetLastUserName"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <button-edit-data
      class="mb-3 mr-2"
      :Form="Shobe"
      :DataParanet="DataAxios"
    ></button-edit-data>
    <div v-for="DataShobeEdits in EditData" :key="DataShobeEdits.id"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ButtonEditData from "../Tools/ButtonEditData.vue";
export default {
  data() {
    return {
      date: "",
      Shobe: "Shobe",
      checkedSms: false,
      NameInFirst: false,
      CanGetSms: false,
      checkedCompressedSms: false,
      images: [],
      TitleUploaderLogo: "بارگذاری لوگو شعبه",
      ClearDescriptionUploaderLogo: "",
      InfoUploaderLogo: "لوگو بارگذاری شد",
      DtlInfoUploaderLogo:
        "برای مشاهده لوگو بارگذاری شده بر روی عکس لوگو کلیک کنید",
      MultipleImaegs: false,
      DataAxios: null,
      EditData: this.$store.state.DefineShobe.EditData,
      Status: false,
    };
  },
  computed: {
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    ...mapState(["DataShobeEdit"]),
    IsSmsactive: {
      get() {
        console.log(this.$store.state.DefineShobe.EditData[0].IsSmsactive);
        return this.$store.state.DefineShobe.EditData[0].IsSmsactive;
      },
      set(value) {
        this.$store.state.DefineShobe.EditData[0].IsSmsactive = value;
      },
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    ButtonEditData,
    VueUploadMultipleImage,
  },
  created() {
    let info;
    let list = [];
    for (let index = 0; index < this.EditData.length; index++) {
      info = this.EditData[index];

      list.push(info);
    }
    this.DataAxios = list[0];
  },
  //   beforeMount(){

  //       let info;
  //     let list=[];
  //     console.log(this.DataShobeEdit)
  //       for (let index = 0; index < this.DataShobeEdit.length; index++) {
  //           info= this.DataShobeEdit[index] ;

  //             list.push(info)
  //       }
  //       console.log(list)
  //       this.DataAxios=list[0]

  //   },
  methods: {
    statusChk: function (event) {
      console.log(this.DataShobe);
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "isSmsactive") {
        if (checkBox.checked == true) {
          this.DataAxios.isSmsactive = true;
        } else {
          this.DataAxios.isSmsactive = false;
        }
      }
      if (checkBox.id == "smsexpect") {
        if (checkBox.checked == true) {
          this.DataAxios.smsexpect = true;
        } else {
          this.DataAxios.smsexpect = false;
        }
      }
      if (checkBox.id == "showNameInFirst") {
        if (checkBox.checked == true) {
          this.DataAxios.showNameInFirst = true;
        } else {
          this.DataAxios.showNameInFirst = false;
        }
      }
      if (checkBox.id == "donotResiveSms") {
        if (checkBox.checked == true) {
          this.DataAxios.donotResiveSms = true;
        } else {
          this.DataAxios.donotResiveSms = false;
        }
      }
    },
    uploadImageSuccess(formData, index, fileList) {
      console.log("data", formData, index, fileList);
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(index, done, fileList) {
      console.log("index", index, fileList);
      // var r = confirm("remove image")
      // if (r == true) {
      //     done()
      // }
      this.$swal({
        title: "حذف عکس کاربر",
        text: "از حذف عکس اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "حذف شود",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "حذف موفق",
            text: "عکس کاربری با موفقیت انجام شد",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "تایید",
          });
          done();
        }
      });
    },
    editImage(formData, index, fileList) {
      console.log("edit data", formData, index, fileList);
    },
    dataChange(data) {
      console.log(data);
    },
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
.nav-link.disabled {
  color: rgb(224, 221, 221);
}
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
}
</style>
